export default "__VITE_ASSET__0a041e4e__"